import { render } from "./footer.vue?vue&type=template&id=43d43cfe&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=43d43cfe&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d43cfe"]])

export default __exports__